import React from "react";
import { RouteConfig } from "../Router";

// const ChatWithYourDataPage = React.lazy(
//   () => import("adminPanel/chatWithYourData/chatWithYourDataPage")
// );

const MenusPage = React.lazy(() => import("adminPanel/menus/MenusPage"));

const EditMenusPage = React.lazy(
  () => import("adminPanel/menus/EditMenusPage"),
);
const PreparedMaterialsPage = React.lazy(
  () => import("adminPanel/preparedMaterials/PreparedMaterialsPage"),
);
const CombosPage = React.lazy(() => import("adminPanel/combos/ComboPage"));
const EditCombosPage = React.lazy(
  () => import("adminPanel/combos/EditCombosPage"),
);

const EditPreparedMaterialsPage = React.lazy(
  () => import("adminPanel/preparedMaterials/EditPreparedMaterialsPage"),
);
const GeneralModifierPage = React.lazy(
  () => import("adminPanel/generalModifier/GeneralModifierPage"),
);
const CreateGeneralModifierPage = React.lazy(
  () => import("adminPanel/generalModifier/EditGeneralModifierPage"),
);

const UserProfile = React.lazy(() => import("amnShared/user/UserProfile"));

const UsersList = React.lazy(() => import("adminPanel/user/UsersList"));
const UserPage = React.lazy(() => import("adminPanel/user/UserPage"));
const TransactionDetails = React.lazy(
  () =>
    import(
      "amnPos/action/finishedTransactions/TransactionDetails/TransactionDetails"
    ),
);
const ShiftSummaryBackOfficePage = React.lazy(
  () =>
    import("adminPanel/reports/FrontEndReports/ShiftSummary/ShiftSummaryPage"),
);
const CalculatedCashDetailsBackOfficePage = React.lazy(
  () =>
    import(
      "adminPanel/reports/FrontEndReports/CalculatedCashDetails/CalculatedCashDetailsPage"
    ),
);
const MaterialsTransactionDetailsBackOfficePage = React.lazy(
  () =>
    import(
      "adminPanel/reports/FrontEndReports/MaterialsTransactionDetails/MaterialsTransactionDetailsPage"
    ),
);
const ExternalTransactionDetailsBackOfficePage = React.lazy(
  () =>
    import(
      "adminPanel/reports/FrontEndReports/ExternalTransactionDetails/ExternalTransactionDetailsPage"
    ),
);
const ShiftClosingDetailsBackOfficePage = React.lazy(
  () =>
    import(
      "adminPanel/reports/FrontEndReports/ShiftClosingDetails/ShiftClosingDetailsPage"
    ),
);
const FinishedOrdersDetails = React.lazy(
  () =>
    import(
      "amnPos/action/finishedOrders/fnishedOrderDetails/FinishedOrdersDetails"
    ),
);

const MainPage = React.lazy(() => import("components/pages/MainPage"));

const PosListPage = React.lazy(() => import("adminPanel/pos/PosListPage"));
const EditPosPage = React.lazy(() => import("adminPanel/pos/EditPosPage"));
const CategoryPage = React.lazy(
  () => import("adminPanel/category/CategoryPage"),
);
const TagListPage = React.lazy(() => import("adminPanel/tags/TagListPage"));
const ItemsPage = React.lazy(() => import("adminPanel/items/ItemsPage"));
const SalesReports = React.lazy(
  () => import("adminPanel/reports/SalesReports"),
);
const UAETaxesInvoicesReport = React.lazy(
  () => import("adminPanel/reports/UAETaxesInvoicesReport"),
);
const SYRTaxesInvoicesReport = React.lazy(
  () => import("adminPanel/reports/SYRTaxesInvoicesReport"),
);
const EGPTaxesReceiptsReports = React.lazy(
  () => import("adminPanel/reports/EGPTaxesReceiptsReports"),
);
const DeliveryCommissionReport = React.lazy(
  () => import("adminPanel/reports/DeliveryCommissionReport"),
);
const CustomerStatementReport = React.lazy(
  () => import("adminPanel/reports/CustomerStatementReport"),
);
const CustomersLeaveWithoutOrderReport = React.lazy(
  () => import("adminPanel/reports/CustomersLeaveWithoutOrder"),
);
const ModifiersSales = React.lazy(
  () => import("adminPanel/reports/ModifiersSales"),
);
const DeferredExternalOrders = React.lazy(
  () => import("adminPanel/reports/DeferredExternalOrders"),
);
const CustomersBalanceStatementReport = React.lazy(
  () => import("adminPanel/reports/CustomersBalanceStatementReport"),
);
const BackOfficeClientStatistics = React.lazy(
  () => import("adminPanel/reports/BackOfficeClientStatistics"),
);
const ShiftReports = React.lazy(
  () => import("adminPanel/reports/ShiftReports"),
);
const DeliveryTripsReport = React.lazy(
  () => import("adminPanel/reports/DeliveryTripsReoprt"),
);
const SupervisorApprovals = React.lazy(
  () => import("adminPanel/reports/SupervisorApprovals"),
);
const DriversLocationsReport = React.lazy(
  () => import("adminPanel/reports/DriversLocationsReport"),
);
const EmployeeStatementReport = React.lazy(
  () => import("adminPanel/reports/EmployeeStatementReport"),
);
const EmployeesBalanceStatementReport = React.lazy(
  () => import("adminPanel/reports/EmployeesBalanceStatementReport"),
);
const AttendanceReport = React.lazy(
  () => import("adminPanel/reports/AttendanceReport"),
);
const TripDetailsBackOfficeReport = React.lazy(
  () => import("adminPanel/reports/TripDetailsReport"),
);
const ReportsPage = React.lazy(() => import("adminPanel/reports/ReportsPage"));
const EditItemPage = React.lazy(() => import("adminPanel/items/EditItemPage"));
const EditClientPage = React.lazy(
  () => import("amnShared/clients/EditClientPage"),
);
const ClientsListPage = React.lazy(
  () => import("adminPanel/clients/ClientsListPage"),
);
const SalesmenPage = React.lazy(
  () => import("adminPanel/salesman/SalesmenPage"),
);
const EditISalesmanPage = React.lazy(
  () => import("adminPanel/salesman/EditISalesmanPage"),
);
const StoresListPage = React.lazy(
  () => import("adminPanel/stores/StoresListPage"),
);
const EditStorePage = React.lazy(
  () => import("adminPanel/stores/EditStorePage"),
);
const EmployeesPage = React.lazy(
  () => import("adminPanel/employee/EmployeesPage"),
);
const EditEmployeePage = React.lazy(
  () => import("adminPanel/employee/EditEmployeePage"),
);
const DriverPage = React.lazy(() => import("adminPanel/driver/DriverPage"));
const EditPrintDesignPage = React.lazy(
  () => import("adminPanel/Print/EditPrintDesignPage"),
);
const DriversCommissionsPage = React.lazy(
  () => import("adminPanel/driversCommissions/DriversCommissionsPage"),
);

const OtherInformationspage = React.lazy(
  () =>
    import(
      "amnShared/orderManagement/ordersEventHistory/OrderEventHistoryPage"
    ),
);

const PrintingDesignListPage = React.lazy(
  () => import("adminPanel/Print/PrintingDesignListPage"),
);
const SettingsPage = React.lazy(
  () => import("adminPanel/settings/SettingsPage"),
);
const DriversPage = React.lazy(() => import("adminPanel/driver/DriversPage"));
const DashboardPage = React.lazy(
  () => import("adminPanel/dashboard/pages/DashboardPage"),
);
const DashboardDetailsPage = React.lazy(
  () => import("adminPanel/dashboard/pages/DashboardDetailsPage"),
);
const DashboardEditPage = React.lazy(
  () => import("adminPanel/dashboard/pages/DashboardEditPage"),
);

const DeliveryCommissionsList = React.lazy(
  () => import("adminPanel/driversCommissions/DeliveryCommisionsList"),
);
const DriverCommissionDetails = React.lazy(
  () => import("adminPanel/driversCommissions/DriverCommissionDetails"),
);
const CalculatedNonCashDetailsPage = React.lazy(
  () =>
    import(
      "adminPanel/reports/FrontEndReports/CalculatedNonCashDetails/CalculatedNonCashDetailsPage"
    ),
);

const adminRoutes = (helpers: {
  getPath: any;
  LoggedIn: any;
  AllowGetPage: any;
  RouterNavigateType: any;
  getClientPagePermissions: any;
}): RouteConfig => ({
  path: helpers.getPath("/"),
  element: helpers.LoggedIn(<MainPage />),
  children: [
    { path: "", element: helpers.LoggedIn(<DashboardPage />) },
    {
      path: helpers.getPath("/dashboard/:id"),
      element: helpers.LoggedIn(<DashboardDetailsPage />),
    },
    {
      path: helpers.getPath("/dashboard/:id/edit"),
      element: helpers.LoggedIn(<DashboardEditPage />),
    },
    {
      path: helpers.getPath("/user-profile"),
      element: helpers.LoggedIn(
        <UserProfile navigateTo={helpers.RouterNavigateType.None} />,
      ),
    },
    {
      path: helpers.getPath("/settings"),
      element: helpers.LoggedIn(<SettingsPage />),
    },
    {
      path: helpers.getPath("/stores"),
      element: helpers.LoggedIn(<StoresListPage />),
    },
    {
      path: helpers.getPath("/users"),
      element: helpers.LoggedIn(<UsersList />),
    },
    {
      path: helpers.getPath("/users-list"),
      element: helpers.LoggedIn(<UsersList />),
    },
    {
      path: helpers.getPath("/stores-list"),
      element: helpers.LoggedIn(<StoresListPage />),
    },
    {
      path: helpers.getPath("/stores-list/create-store"),
      element: helpers.LoggedIn(<EditStorePage />),
    },
    {
      path: helpers.getPath("/stores-list/edit-store/:id"),
      element: helpers.LoggedIn(<EditStorePage />),
    },
    {
      path: helpers.getPath("/stores-list/edit-client/:id"),
      element: helpers.LoggedIn(<EditStorePage />),
    },
    {
      path: helpers.getPath("/clients"),
      element: helpers.LoggedIn(<ClientsListPage />),
    },
    {
      path: helpers.getPath("/clients-list"),
      element: helpers.LoggedIn(<ClientsListPage />),
    },
    {
      path: helpers.getPath("/clients-list/create-client"),
      element: helpers.LoggedIn(
        <EditClientPage navigateTo={helpers.RouterNavigateType.None} />,
      ),
    },
    {
      path: helpers.getPath("/clients-list/edit-client/:id"),
      element: helpers.LoggedIn(
        <EditClientPage navigateTo={helpers.RouterNavigateType.None} />,
      ),
    },
    {
      path: helpers.getPath("/category-list"),
      element: helpers.LoggedIn(<CategoryPage />),
    },
    {
      path: helpers.getPath("/category-list/:backTo"),
      element: helpers.LoggedIn(<CategoryPage />),
    },
    {
      path: helpers.getPath("/tag-list"),
      element: helpers.LoggedIn(<TagListPage />),
    },
    {
      path: helpers.getPath("/tag-list/:backTo"),
      element: helpers.LoggedIn(<TagListPage />),
    },
    {
      path: helpers.getPath("/materials"),
      element: helpers.LoggedIn(<ItemsPage />),
    },
    {
      path: helpers.getPath("/materialsAndServicesList"),
      element: helpers.LoggedIn(<ItemsPage />),
    },
    {
      path: helpers.getPath("/reports"),
      element: helpers.LoggedIn(<ReportsPage />),
    },
    {
      path: helpers.getPath("/sales-summary"),
      element: helpers.LoggedIn(<SalesReports />),
    },
    {
      path: helpers.getPath("/egp-taxes-receipts"),
      element: helpers.LoggedIn(<EGPTaxesReceiptsReports />),
    },
    {
      path: helpers.getPath("/syr-taxes-invoices"),
      element: helpers.LoggedIn(<SYRTaxesInvoicesReport />),
    },
    {
      path: helpers.getPath("/uae-taxes-invoices"),
      element: helpers.LoggedIn(<UAETaxesInvoicesReport />),
    },
    {
      path: helpers.getPath("/delivery-commission-report"),
      element: helpers.LoggedIn(<DeliveryCommissionReport />),
    },
    {
      path: helpers.getPath("/customer-statement-report"),
      element: helpers.LoggedIn(<CustomerStatementReport />),
    },
    {
      path: helpers.getPath("/customer-statement-report/:id"),
      element: helpers.LoggedIn(<CustomerStatementReport />),
    },
    {
      path: helpers.getPath("/customers-leave-without-order"),
      element: helpers.LoggedIn(<CustomersLeaveWithoutOrderReport />),
    },
    {
      path: helpers.getPath("/modifiers-sales"),
      element: helpers.LoggedIn(<ModifiersSales />),
    },
    {
      path: helpers.getPath("/deferred-external-orders"),
      element: helpers.LoggedIn(<DeferredExternalOrders />),
    },
    {
      path: helpers.getPath("/customers-balance-statement-report"),
      element: helpers.LoggedIn(<CustomersBalanceStatementReport />),
    },
    {
      path: helpers.getPath("/customer-statistics"),
      element: helpers.LoggedIn(<BackOfficeClientStatistics />),
    },
    {
      path: helpers.getPath("/customer-statistics/:id"),
      element: helpers.LoggedIn(<BackOfficeClientStatistics />),
    },
    {
      path: helpers.getPath("/shift-summary"),
      element: helpers.LoggedIn(<ShiftReports />),
    },
    {
      path: helpers.getPath("/delivery-trips-report"),
      element: helpers.LoggedIn(<DeliveryTripsReport />),
    },
    {
      path: helpers.getPath("/employee-statement-report"),
      element: helpers.LoggedIn(<EmployeeStatementReport />),
    },
    {
      path: helpers.getPath("/employee-statement-report/:id"),
      element: helpers.LoggedIn(<EmployeeStatementReport />),
    },
    {
      path: helpers.getPath("/employees-balance-statement-report"),
      element: helpers.LoggedIn(<EmployeesBalanceStatementReport />),
    },
    {
      path: helpers.getPath("/attendance-report"),
      element: helpers.LoggedIn(<AttendanceReport />),
    },
    {
      path: helpers.getPath("/supervisor-approvals-report"),
      element: helpers.LoggedIn(<SupervisorApprovals />),
    },
    {
      path: helpers.getPath("/drivers-location-report"),
      element: helpers.LoggedIn(<DriversLocationsReport />),
    },
    {
      path: helpers.getPath("/tripDetailsReport/:id"),
      element: helpers.LoggedIn(<TripDetailsBackOfficeReport />),
    },
    {
      path: helpers.getPath("/materials/create-material"),
      element: helpers.LoggedIn(<EditItemPage />),
    },
    {
      path: helpers.getPath("/materials/edit-material/:id"),
      element: helpers.LoggedIn(<EditItemPage />),
    },
    {
      path: helpers.getPath("/menus"),
      element: helpers.LoggedIn(<MenusPage />),
    },
    {
      path: helpers.getPath("/menusList"),
      element: helpers.LoggedIn(<MenusPage />),
    },
    {
      path: helpers.getPath("/menusList/create-menu"),
      element: helpers.LoggedIn(<EditMenusPage />),
    },
    {
      path: helpers.getPath("/menusList/edit-menu/:id"),
      element: helpers.LoggedIn(<EditMenusPage />),
    },
    {
      path: helpers.getPath("/comboList"),
      element: helpers.LoggedIn(<CombosPage />),
    },
    {
      path: helpers.getPath("/comboList/create-combo"),
      element: helpers.LoggedIn(<EditCombosPage />),
    },
    {
      path: helpers.getPath("/comboList/edit-combo/:id"),
      element: helpers.LoggedIn(<EditCombosPage />),
    },
    {
      path: helpers.getPath("/preparedMaterials"),
      element: helpers.LoggedIn(<PreparedMaterialsPage />),
    },
    {
      path: helpers.getPath("/preparedMaterials/create-preparedMaterial"),
      element: helpers.LoggedIn(<EditPreparedMaterialsPage />),
    },
    {
      path: helpers.getPath("/preparedMaterials/edit-preparedMaterial/:id"),
      element: helpers.LoggedIn(<EditPreparedMaterialsPage />),
    },
    {
      path: helpers.getPath("/generalModifiersList"),
      element: helpers.LoggedIn(<GeneralModifierPage />),
    },
    {
      path: helpers.getPath("/generalModifiersList/create-generalModifier"),
      element: helpers.LoggedIn(<CreateGeneralModifierPage />),
    },
    {
      path: helpers.getPath("/generalModifiersList/edit-generalModifier/:id"),
      element: helpers.LoggedIn(<CreateGeneralModifierPage />),
    },
    {
      path: helpers.getPath("/salesmen"),
      element: helpers.LoggedIn(<SalesmenPage />),
    },
    {
      path: helpers.getPath("/salesmen/create-Salesman"),
      element: helpers.LoggedIn(<EditISalesmanPage />),
    },
    {
      path: helpers.getPath("/salesmen/edit-Salesman/:id"),
      element: helpers.LoggedIn(<EditISalesmanPage />),
    },
    {
      path: helpers.getPath("/staff"),
      element: helpers.LoggedIn(<EmployeesPage />),
    },
    {
      path: helpers.getPath("/deliveryCommissions"),
      element: helpers.LoggedIn(<DriversCommissionsPage />),
    },
    {
      path: helpers.getPath("/deliveryCommissionsList/:id"),
      element: helpers.LoggedIn(<DeliveryCommissionsList />),
    },
    {
      path: helpers.getPath("/deliveryCommissionsList/:startDate/:endDate"),
      element: helpers.LoggedIn(<DeliveryCommissionsList />),
    },
    {
      path: helpers.getPath(
        "/deliveryCommissions/driverCommissionDetails/:startDate?/:endDate?/:id",
      ),
      element: helpers.LoggedIn(<DriverCommissionDetails />),
    },
    {
      path: helpers.getPath("/deliveryCommissions/driverCommissionDetails/:id"),
      element: helpers.LoggedIn(<DriverCommissionDetails />),
    },
    {
      path: helpers.getPath(
        "/OrderManagement/OrdersEventHistory/:id/:delivery",
      ),
      element: helpers.LoggedIn(<OtherInformationspage />),
    },
    {
      path: helpers.getPath("/finished-orders/:id"),
      element: helpers.LoggedIn(<FinishedOrdersDetails />),
    },
    {
      path: helpers.getPath("/cashiersAndSupervisors"),
      element: helpers.LoggedIn(<EmployeesPage />),
    },
    {
      path: helpers.getPath("/create-employee"),
      element: helpers.LoggedIn(<EditEmployeePage />),
    },
    {
      path: helpers.getPath("/edit-employee/:id"),
      element: helpers.LoggedIn(<EditEmployeePage />),
    },
    {
      path: helpers.getPath("/users/create"),
      element: helpers.LoggedIn(<UserPage />),
    },
    {
      path: helpers.getPath("/users/:id"),
      element: helpers.LoggedIn(<UserPage />),
    },
    {
      path: helpers.getPath("/pos-list"),
      element: helpers.LoggedIn(<PosListPage />),
    },
    {
      path: helpers.getPath("/edit-pos"),
      element: helpers.LoggedIn(<EditPosPage />),
    },
    {
      path: helpers.getPath("/create-pos"),
      element: helpers.LoggedIn(<EditPosPage />),
    },
    {
      path: helpers.getPath("/edit-pos/:id"),
      element: helpers.LoggedIn(<EditPosPage />),
    },
    {
      path: helpers.getPath("/Driver"),
      element: helpers.LoggedIn(<DriversPage />),
    },
    {
      path: helpers.getPath("/Driver/create-driver"),
      element: helpers.LoggedIn(<DriverPage />),
    },
    {
      path: helpers.getPath("/Driver/edit-driver/:id"),
      element: helpers.LoggedIn(<DriverPage />),
    },
    {
      path: helpers.getPath("/printDesign-list"),
      element: helpers.LoggedIn(<PrintingDesignListPage />),
    },
    {
      path: helpers.getPath("/printDesign-list/create-print-design"),
      element: helpers.LoggedIn(<EditPrintDesignPage />),
    },
    {
      path: helpers.getPath("/printDesign-list/edit-print-design/:id"),
      element: helpers.LoggedIn(<EditPrintDesignPage />),
    },
    {
      path: helpers.getPath("/shiftSummary/:id"),
      element: helpers.LoggedIn(<ShiftSummaryBackOfficePage />),
    },
    {
      path: helpers.getPath("/calculatedCashDetails/:id"),
      element: helpers.LoggedIn(<CalculatedCashDetailsBackOfficePage />),
    },
    {
      path: helpers.getPath("/calculatedNonCashDetails/:id"),
      element: helpers.LoggedIn(<CalculatedNonCashDetailsPage />),
    },
    {
      path: helpers.getPath("/materialsTransactionDetails/:id"),
      element: helpers.LoggedIn(<MaterialsTransactionDetailsBackOfficePage />),
    },
    {
      path: helpers.getPath("/externalTransactionDetails/:id"),
      element: helpers.LoggedIn(<ExternalTransactionDetailsBackOfficePage />),
    },
    {
      path: helpers.getPath("/shiftClosingDetails/:id"),
      element: helpers.LoggedIn(<ShiftClosingDetailsBackOfficePage />),
    },
    {
      path: helpers.getPath("/materialsTransactions/finished/:id"),
      element: helpers.LoggedIn(<TransactionDetails />),
    },
    // { path: helpers.getPath("/ChatWithYourDataP"), element: helpers.LoggedIn(<ChatWithYourDataPage />) },
    { path: "*", element: <div>Invalid route</div> },
  ],
});

export default adminRoutes;
